if (!__DEV__) {
  console.log = function() {
    void 0;
  };
}

import './app';
import './directives';
import './appInterceptors';
